<template>
    <div>
        <a :href="storeUrl" class="image align-self-center logo-container">
            <img v-if="item.thumbnail" :src="item.thumbnail.public_path + '?size=list'" class="logo" :alt="item.thumbnail.alt"/>
        </a>

        <div class="body">
            <h4 class="catalog-item-title text-center py-2 py-sm-3">{{ item.title }}</h4>
            <a class="btn btn-primary d-flex flex-nowrap align-items-center justify-content-center" :href="storeUrl">
                <span>{{btnText}}</span>
                <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon ms-3">
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object,
        locale: String
    },
    computed: {
        btnText() {
            return this.locale == 'es' ? 'Ver tienda' : 'See shop';
        },
        storeUrl() {
            return this.locale == 'es' ? `/${this.locale}/tiendas/${this.item.slug}` :  `/${this.locale}/stores/${this.item.slug}`;
        }
    }
}
</script>
<style>
.item.col-md-3.p-3{
    height: 100%;
}
.item.col-md-3.p-3 div{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
.item.col-md-3.p-3 .image{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    background-color: white;
}
.item.col-md-3.p-3 div .image h4{
    margin-top: 10px;
    font-weight: 500;
}
.catalog-item-title{
    font-size: .9em;
    font-weight: 600;
    height: 45px;
    overflow: hidden;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image {
    text-align: -webkit-center;
}
</style>